import { EventAvailableOutlined as EventAvailableOutlinedIcon } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { ExtraDataStyle } from './JobItem.styles';
import { formatJobUpdatedTime } from './jobUpdatedTime.utils';

type JobUpdatedTimeProps = {
    date: string | Date;
};

export default function JobUpdatedTime({ date }: JobUpdatedTimeProps) {
    const label = formatJobUpdatedTime(date);

    if (!label) return null;

    return <ExtraDataStyle alignItems="center" display="flex">
        <EventAvailableOutlinedIcon fontSize="small" color="secondary" />
        <Typography component="time" display="inline" dateTime={new Date(date).toISOString()} suppressHydrationWarning>
            {`\u00a0${label}`}
        </Typography>
    </ExtraDataStyle>;
}
